// extracted by mini-css-extract-plugin
export var image = "Avatar-module--image--70e43";
export var placeholder = "Avatar-module--placeholder--f0d97";
export var root = "Avatar-module--root--1ef22";